if (!customElements.get('pickup-availability')) {
  customElements.define('pickup-availability', class PickupAvailability extends HTMLElement {
    constructor() {
      super();

      if (!this.hasAttribute('available')) return;

      this.onClickRefreshList = this.onClickRefreshList.bind(this);
      this.fetchAvailability(this.dataset.variantId);

    }

    fetchAvailability(variantId) {
      let rootUrl = this.dataset.rootUrl;
      if (!rootUrl.endsWith("/")) {
        rootUrl = rootUrl + "/";
      }
      const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;

      fetch(variantSectionUrl)
        .then(response => response.text())
        .then(text => {
          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('.shopify-section');
          this.renderPreview(sectionInnerHTML);

        })
        .catch(e => {
          const button = this.querySelector('button');
          if (button) button.removeEventListener('click', this.onClickRefreshList);
          this.renderError();
        });
    }

    onClickRefreshList(evt) {
      this.fetchAvailability(this.dataset.variantId);
    }

    // Code by Ruby - Convx - TL-4122
    applySpecialLocationMessages() {
      const panel = document.getElementById('Pickup-Availability');
      if (!panel) return;
      const inner = panel.querySelector('.side-panel-inner');
      const specialTagsStr = (inner && inner.getAttribute('data-special-tags')) ? inner.getAttribute('data-special-tags').trim() : '';
      const productTagsStr = (this.dataset.productTags || '').trim();
      // Code by Ruby - Convx - TL-4155
      // const specialMessage = (this.dataset.specialMessage || '').trim();
      const specialMessage = (this.dataset.specialMessage || '').replace(/\\n/g, '\n').trim();
      // End of TL-4155

      const specialTagsList = specialTagsStr ? specialTagsStr.split(',').map(t => t.trim().toUpperCase()).filter(Boolean) : [];
      const productTagsList = productTagsStr ? productTagsStr.split(',').map(t => t.trim().toUpperCase()).filter(Boolean) : [];

      const productHasSpecialTag = specialTagsList.length > 0 && productTagsList.some(pt => specialTagsList.includes(pt));

      panel.querySelectorAll('.pickup-availability-list__item[data-is-special-location="true"]').forEach((item) => {
        const span = item.querySelector('.pickup-availability-list__in-stock-text');
        if (span && productHasSpecialTag && specialMessage) {
          span.textContent = specialMessage;
          // Code by Ruby - Convx - TL-4155
          span.classList.add('pickup-availability-list__in-stock-text--multiline');
          // End of TL-4155
        }
      });
    }
    // End of TL-4122

    renderError() {
      this.innerHTML = '';

			if ( this.querySelector('button') ) {
	      this.querySelector('button').addEventListener('click', this.onClickRefreshList);
			}
    }

    renderPreview(sectionInnerHTML) {
      const drawer = document.querySelector('.pickup-availability-drawer');
      if (drawer) drawer.remove();
      if (!sectionInnerHTML.querySelector('.pickup-availability-information')) {
        this.innerHTML = "";
        this.removeAttribute('available');
        return;
      }

      this.innerHTML = sectionInnerHTML.querySelector('.pickup-availability-information').innerHTML;
      this.setAttribute('available', '');

      document.getElementById('Pickup-Availability').innerHTML = sectionInnerHTML.querySelector('.side-availability').innerHTML;

      // Code by Ruby - Convx - TL-4122
      this.applySpecialLocationMessages();
      // End of TL-4122

      const button = this.querySelector('button');
      if (button) button.addEventListener('click', (evt) => {
        // Code by Ruby - Convx - TL-3171 - comment the original code

        // document.getElementById('Pickup-Availability').classList.toggle("active");
        // document.getElementsByTagName("body")[0].classList.toggle('open-cc');
        // let panel = document.querySelectorAll('.side-panel.active');
        // if (!panel.classList.contains('active')) {
        //     this.onClickRefreshList();
        // }
        // evt.preventDefault();

        const panel = document.getElementById('Pickup-Availability');
        
        // Don't open panel if it's currently being closed
        if (panel && panel.dataset && panel.dataset.isClosing === 'true') {
          evt.preventDefault();
          evt.stopPropagation();
          return;
        }
        
        if (panel && !panel.classList.contains('active')) {
          panel.classList.add("active");
          document.getElementsByTagName("body")[0].classList.add('open-cc');
        }

        
        let panels = document.querySelectorAll('.side-panel');
        let hasActive = Array.from(panels).some(p => p.classList.contains('active'));

        if (!hasActive) {
          this.onClickRefreshList();
        }
        
        evt.preventDefault();
        evt.stopPropagation();
        // End of TL-3171
      });
    }
  });
}
